import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=c572c89c"
var script = {}
import style0 from "./Insights.vue?vue&type=style&index=0&id=c572c89c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports